import { Component, OnInit, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ContractDto } from 'src/app/models/contractDto';
import { CostCenterDto } from 'src/app/models/CostCenterDto';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { LocationDto } from 'src/app/models/LocationDto';
import { NotificationType } from 'src/app/models/notification.message';
import { ContractVm } from 'src/app/models/requests/ConractVm';
import { VendorDto } from 'src/app/models/VendorDto';
import { ContractsService } from 'src/app/services/contracts.service';
import { CostCentersService } from 'src/app/services/costcenters.service';
import { DepartmentsService } from 'src/app/services/departments.service';
import { LocationsService } from 'src/app/services/locations.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { VendorsService } from 'src/app/services/vendors.service';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { Profile } from 'src/app/models/profile';
import { UserService } from 'src/app/services/user.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AdHocService } from 'src/app/services/ad-hoc.service';
import { adhocVm } from 'src/app/models/requests/adhocVm';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-new-adhoc',
  templateUrl: './new-adhoc.component.html',
  styleUrls: ['./new-adhoc.component.css']
})
export class NewAdhocComponent implements OnInit {

   @ViewChild('ngNewAdhocForm') theForm!: NgForm;

  plantName: string ='';
  sectionOrDepartment: string = ''
  numberRequired: number = 0; 
  serviceProvider: string = '';
  jobDescription: string = '';
  skillsRequired: string = '';
  startDate:Date = new Date;
  endDate: Date = new Date;  
  numberOfDays: number = 0; 
  costCenterId: number = 0;
  dateOfRequest: Date = new Date;
  requesterName: string = '';
  lineManagerToApprove: string = '';
  hodToApprove: string = '';
  plantControllerToApprove: string = '';
  hrbpToApprove: string = '';
  Vendors: VendorDto[] = [];
  vendorId: number = 0;
  cost: number = 0;

  HRBPS:Profile[]=[];
  Managers:Profile[]=[];
  PlantManagers:Profile[]=[];
  Departments: DepartmentDto[] = [];
  CostCenters: CostCenterDto[] | undefined;
  Locations: LocationDto[] | undefined;
  selectedLocationId: number = 0;
  selectedDepartmentId: number = 0;
  selectedCostCenterId: number = 0;
  procurementDirectorToApprove: string = '';
  FunctionalDirectors:Profile[]=[];
  ohrdToApprove: string = '';

  currentUser: any;
  email: string = '';
  userLocationId: number = 0;
  isSubmitting: boolean = false 

  Plants: LocationDto[] | undefined;

  constructor(private adhocService: AdHocService,   private locationService: LocationsService,
    private departmentService: DepartmentsService, private contractService: ContractsService, private notification: NotificationService,
    private costCenterService: CostCentersService, private nznotification: NzNotificationService, private tokenService: TokenService,  private userService: UserService,
    private vendorService: VendorsService) { }

  ngOnInit(): void {
    this.LoadDropDowns();
  }

  getInfo(){
    this.currentUser = this.tokenService.getInfo();
    this.email = this.currentUser.profile.email;
    this.userLocationId = this.currentUser.profile.locationId;
  }

  async LoadDropDowns() {

    // if (this.isShowPlantManager == false){
    //   this.hrbpCount = 2
    //   this.funcdirectorCount = 3
    //   this.procurementDirector = 4
    //   this.hrCount = 5
   
    // }
    let resLocations = await this.locationService.getPlantLocations().toPromise();
    this.Locations = <LocationDto[]>resLocations.responseData;

    let resCostCenterss = await this.costCenterService.getCostCenters().toPromise();
    this.CostCenters = <CostCenterDto[]>resCostCenterss.responseData;

    var profile = this.tokenService.getInfo();
    this.selectedDepartmentId = profile.profile.departmentId;


    let plantManager = await this.userService.getManagersUsers().toPromise();
    this.PlantManagers = <Profile[]>plantManager.responseData;

    let usersPro = await this.userService.getManagersUsers().toPromise();
    this.Managers = <Profile[]>usersPro.responseData;

    let userhrpbps = await this.userService.getHRBPS().toPromise();
    this.HRBPS = <Profile[]>userhrpbps.responseData;
    
    let procurementDirector = await this.userService.getProcurementDirector().toPromise();
    let procurementDirectorRes = <Profile[]>procurementDirector.responseData;
    this.procurementDirectorToApprove = procurementDirectorRes[0].email;

    let ohrDirector = await this.userService.getOHRDirector().toPromise();
    let ohrDirectorRes = <Profile[]>ohrDirector.responseData;
    this.ohrdToApprove = ohrDirectorRes[0].email;
     
    let resDeparts = await this.departmentService.getDepartments().toPromise();
    this.Departments = <DepartmentDto[]>resDeparts.responseData;

    let directors = await this.userService.getFunctionalDirectors().toPromise();
    this.FunctionalDirectors = <Profile[]>directors.responseData;

    try {
      let resVendors = await this.vendorService.getVendors().toPromise();
      this.Vendors = <VendorDto[]>resVendors.responseData;
    } catch (err) {
      console.error('Failed to load vendors', err);
    }
  }

  onSubmit(): void {
    this.isSubmitting = true;
    let adhocRequest: adhocVm = {
      plantName:  this.plantName,
      sectionOrDepartment:  this.sectionOrDepartment,
      numberRequired:  this.numberRequired,
      jobDescription:  this.jobDescription,
      skillsRequired:  this.skillsRequired,
      startDate:  this.startDate,
      endDate:  this.endDate,
      costCenterId:  this.costCenterId,
      dateOfRequest:  new Date,
      requesterName:  this.email,
      lineManagerToApprove:  this.lineManagerToApprove,
      hodToApprove:  this.hodToApprove,
      plantControllerToApprove:  this.plantControllerToApprove,
      hrbpToApprove:  this.hrbpToApprove,
      locationId: this.userLocationId, 
      vendorId: this.vendorId,
      vendorCost: this.cost,
    }

    console.log('this is the payload: ', adhocRequest);

    this.adhocService.saveAdhoc(adhocRequest).subscribe(
      (response) => {
        if(response.requestSuccessful){
          this.notification.sendMessage({
            message: response.message,
            type: NotificationType.success
          });
          location.reload();
        } else {

            this.notification.sendMessage({
              message: response.message,
              type: NotificationType.error
            });
          this.isSubmitting = false;


          }
      }
    ), (err: any) => {
      this.notification.sendMessage({
        message: 'error! try again',
        type: NotificationType.error
      })
      console.log(err.error.message);
      this.isSubmitting = false;

    }
  }

  onCancel() {
    this.theForm.resetForm();
  }

}

